import React from 'react';
import { GridLegacy as Grid, Typography } from '@mui/material';

const DATA = {
  FEEDS: 'Source provides some media (ex: water or air) to Target.',
  CONTAINS: 'Source physically encapsulates at least part of Target.',
};

const Relationships = ({ attr }) => (
  <div className="leaf relationship">
    <Typography variant="h5" className="name">
      {attr}
    </Typography>

    <Grid item xs={2}>
      <Typography variant="h6">Description:</Typography>
    </Grid>
    <Grid item xs={8} className="static-attr">
      <Typography>{DATA[attr]}</Typography>
    </Grid>
  </div>
);

export default Relationships;
